module.exports = __webpack_public_path__ + "public/img/Dasar Keselamatan dan Kesehatan Kerja di Tempat Kerja.cb5a6b72.png";